(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-black-friday-duo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-bf-duo-scale')) {
    customElements.define('ob-bf-duo-scale', class extends HTMLElement {
      connectedCallback() {
        if (this.resizeObserver || !('ResizeObserver' in window)) return;
        this.content = this.querySelector('.ob-bf-duo__scale-content');
        if (!this.content) return;
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.updateScale = () => {
          if (!this.desktop.matches) {
            this.removeAttribute('data-scaled');
            this.style.removeProperty('--ob-bf-flow-height');
            return;
          }
          this.style.setProperty('--ob-bf-flow-height', `${this.content.offsetHeight * .86}px`);
          this.setAttribute('data-scaled', '');
        };
        this.resizeObserver = new ResizeObserver(this.updateScale);
        this.resizeObserver.observe(this.content);
        this.desktop.addEventListener('change', this.updateScale);
        this.updateScale();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.desktop?.removeEventListener('change', this.updateScale);
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('origen-brand-marquee')) {
    customElements.define('origen-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.ob-brand-marquee__toggle');
        if (!this.button) return;
        this.onToggle = () => {
          const paused = this.classList.toggle('is-paused');
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.setAttribute('aria-label', paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
        };
        this.button.addEventListener('click', this.onToggle);
        this.button.hidden = false;
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        if (this.button && this.onToggle) this.button.removeEventListener('click', this.onToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen-home-inspiration"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ob26-finish-library')) {
  customElements.define('ob26-finish-library', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.tabs = Array.from(this.querySelectorAll('[data-finish-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-finish-panel]'));
      const list = this.querySelector('[data-finish-tablist]');
      if (!list || this.tabs.length === 0 || this.tabs.length !== this.panels.length) return;
      this.events = new AbortController();
      const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.events.signal });
      this.railStates = [];
      this.activeIndex = 0;
      this.viewportQuery = window.matchMedia('(max-width: 749px)');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const updateOrientation = () => list.setAttribute('aria-orientation', 'horizontal');
      list.setAttribute('role', 'tablist');
      updateOrientation();
      listen(this.viewportQuery, 'change', updateOrientation);
      this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        const rail = panel.querySelector('[data-finish-rail]');
        if (!rail) return;
        const state = {
          panel,
          rail,
          previous: panel.querySelector('[data-carousel-prev]'),
          next: panel.querySelector('[data-carousel-next]'),
          help: panel.querySelector('[data-carousel-help]'),
          frame: 0,
          drag: null,
          suppressClickUntil: 0
        };
        this.railStates.push(state);
        const move = direction => this.moveRail(state, direction);
        if (state.previous) listen(state.previous, 'click', () => move(-1));
        if (state.next) listen(state.next, 'click', () => move(1));
        listen(rail, 'scroll', () => this.scheduleRailUpdate(state), { passive: true });
        listen(rail, 'keydown', event => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowLeft' ? -1 : 1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth - rail.clientWidth, behavior: this.motionQuery.matches ? 'auto' : 'smooth' });
          }
        });
        listen(rail, 'dragstart', event => event.preventDefault());
        listen(rail, 'pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
          if (rail.scrollWidth <= rail.clientWidth + 1) return;
          state.drag = { id: event.pointerId, startX: event.clientX, startScroll: rail.scrollLeft, active: false };
        });
        listen(rail, 'pointermove', event => {
          const drag = state.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const distance = event.clientX - drag.startX;
          if (!drag.active && Math.abs(distance) < 7) return;
          if (!drag.active) {
            drag.active = true;
            rail.classList.add('is-dragging');
            try { rail.setPointerCapture(event.pointerId); } catch (_) {}
          }
          event.preventDefault();
          rail.scrollLeft = drag.startScroll - distance;
        });
        const endDrag = event => {
          const drag = state.drag;
          if (!drag || event.pointerId !== drag.id) return;
          state.drag = null;
          if (drag.active) state.suppressClickUntil = Date.now() + 350;
          rail.classList.remove('is-dragging');
          if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
          this.scheduleRailUpdate(state);
        };
        listen(rail, 'pointerup', endDrag);
        listen(rail, 'pointercancel', endDrag);
        listen(rail, 'lostpointercapture', endDrag);
        listen(rail, 'pointerleave', event => {
          if (state.drag && !state.drag.active) state.drag = null;
        });
        listen(rail, 'click', event => {
          if (event.detail !== 0 && Date.now() < state.suppressClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
            state.suppressClickUntil = 0;
          }
        }, { capture: true });
      });
      listen(list, 'click', event => {
        const tab = event.target.closest('[data-finish-tab]');
        if (tab && list.contains(tab)) this.selectFinish(this.tabs.indexOf(tab));
      });
      listen(list, 'keydown', event => {
        const tab = event.target.closest('[data-finish-tab]');
        if (!tab || !list.contains(tab)) return;
        const index = this.tabs.indexOf(tab);
        let next = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.selectFinish(next, true);
      });
      listen(this, 'shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index !== -1) this.selectFinish(index);
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            const state = this.railStates.find(item => item.rail === entry.target);
            if (state) this.scheduleRailUpdate(state);
          });
        });
        this.railStates.forEach(state => this.resizeObserver.observe(state.rail));
      } else {
        listen(window, 'resize', () => this.railStates.forEach(state => this.scheduleRailUpdate(state)), { passive: true });
      }
      const initial = this.tabs.findIndex(tab => tab.dataset.finishKey === this.dataset.defaultFinish);
      this.selectFinish(initial === -1 ? 0 : initial);
      this.dataset.ready = 'true';
    }
    selectFinish(index, focus = false) {
      if (index < 0 || index >= this.tabs.length) return;
      this.activeIndex = index;
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        this.panels[position].hidden = !selected;
      });
      const state = this.railStates.find(item => item.panel === this.panels[index]);
      if (state) this.scheduleRailUpdate(state);
      if (focus) this.tabs[index].focus();
    }
    moveRail(state, direction) {
      const step = Math.max(1, state.rail.clientWidth * 0.88);
      state.rail.scrollBy({ left: direction * step, behavior: this.motionQuery.matches ? 'auto' : 'smooth' });
    }
    scheduleRailUpdate(state) {
      if (state.frame) cancelAnimationFrame(state.frame);
      state.frame = requestAnimationFrame(() => {
        state.frame = 0;
        if (state.panel.hidden || state.rail.clientWidth === 0) return;
        const maximum = Math.max(0, state.rail.scrollWidth - state.rail.clientWidth);
        const position = Math.max(0, Math.min(maximum, state.rail.scrollLeft));
        state.rail.dataset.overflow = String(maximum > 1);
        if (state.previous) state.previous.disabled = position <= 1;
        if (state.next) state.next.disabled = position >= maximum - 1;
        if (state.help) state.help.hidden = maximum <= 1;
      });
    }
    disconnectedCallback() {
      if (this.events) this.events.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.railStates) this.railStates.forEach(state => {
        if (state.frame) cancelAnimationFrame(state.frame);
        state.rail.classList.remove('is-dragging');
        if (state.drag && state.rail.hasPointerCapture(state.drag.id)) state.rail.releasePointerCapture(state.drag.id);
        state.drag = null;
      });
      delete this.dataset.ready;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-discount-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSummerDiscount = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const dialog = section.querySelector('[data-summer-discount-dialog]');
      const openButton = section.querySelector('[data-summer-discount-open]');
      const closeButton = section.querySelector('[data-summer-discount-close]');
      const success = section.querySelector('[data-summer-discount-success]');
      const errorMessage = section.querySelector('[data-summer-discount-error]');
      const codeButton = section.querySelector('[data-discount-code]');
      const storageKey = section.dataset.storageKey;

      if (!dialog || !openButton) return;

      const openDialog = () => {
        if (!dialog.open) dialog.showModal();
      };

      const closeDialog = () => {
        if (dialog.open) dialog.close();
        try {
          localStorage.setItem(storageKey, String(Date.now()));
        } catch (storageError) {
          // Storage can be unavailable in privacy-focused browsers.
        }
      };

      openButton.addEventListener('click', openDialog);
      closeButton?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      codeButton?.addEventListener('click', async () => {
        const code = codeButton.dataset.discountCode;
        const label = codeButton.querySelector('[data-copy-label]');
        try {
          await navigator.clipboard.writeText(code);
          if (label) label.textContent = codeButton.dataset.copiedLabel || 'Código copiado';
        } catch (clipboardError) {
          if (label) label.textContent = code;
        }
      });

      if (success || errorMessage) {
        openDialog();
        success?.focus();
        return;
      }

      if (section.dataset.autoOpen !== 'true' || Shopify.designMode) return;

      let lastDismissed = 0;
      try {
        lastDismissed = Number(localStorage.getItem(storageKey) || 0);
      } catch (storageError) {
        // Continue without persistence when storage is unavailable.
      }

      const sevenDays = 7 * 24 * 60 * 60 * 1000;
      if (Date.now() - lastDismissed < sevenDays) return;

      const delay = Number(section.dataset.openDelay || 2) * 1000;
      window.setTimeout(openDialog, delay);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-summer-discount]').forEach(initSummerDiscount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
